export { default } from "./RolesQuery";



// WEBPACK FOOTER //
// ./src/queries/RolesQuery/index.ts